import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import {
  Input,
  Button,
  CardActions,
  Typography,
  Divider,
} from '@material-ui/core'

import SweetAlert from 'sweetalert2-react'
import AsyncSelect from 'react-select/lib/Async'

import RegularCard from '../Cards/RegularCard.js'
import { expert as expertActions } from '../../actions/expert.actions'
import CustomMultiSelect from 'components/Input/CustomMultiSelect.js'
import CustomTextField from 'components/Input/CustomTextField.js'

import { user as userApi } from '../../api/modules/user.api'

// @TODO: Add loading spinner (see CategoryForm)

const form = 'expert'
const selector = formValueSelector(form)

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'Required'
  }
  return errors
}

const onSubmit = (values, dispatch, props) => {
  values.objectId = props.initialValues.objectId
  values.user_id = props.initialValues.user_id
  values.accountNumber = parseInt(values.accountNumber, 0)
  props.save(values)
}

class ExpertsForm extends Component {
  handleChangeImage(e) {}

  componentDidMount() {
    this.props.getExpertRegions()
    if (this.props.match.params.id) {
      this.props.getExpert(this.props.match.params.id)
    } else {
      this.props.newExpert()
    }
  }
  hideAlert(event) {
    this.props.hideAlert()
    this.props.history.push('/expert')
  }
  render() {
    const { regions, handleSubmit, saved, errorMessage } = this.props
    const title = this.props.match.params.id ? 'Edit Expert' : 'Add new Expert'
    return (
      <div>
        <RegularCard
          cardTitle={title}
          content={
            <form onSubmit={handleSubmit}>
              <Typography
                variant="h5"
                style={{ textAlign: 'center' }}
                gutterBottom
              >
                Personal Details
              </Typography>
              <Divider style={{ marginBottom: '20px' }} />
              <Field
                name="user"
                label="User"
                placeholder="Search by email…"
                loadOptions={userApi.select}
                component={props => (
                  <AsyncSelect
                    {...props}
                    {...props.input}
                    multi
                    loadOptions={userApi.select}
                  />
                )}
              />
              <div>
                <label>Regions</label>
                <Field
                  name="expertRegions"
                  label="Regions"
                  placeholder="Select regions"
                  options={regions.map(r => ({
                    label: r.regionName,
                    value: r.objectId,
                  }))}
                  component={CustomMultiSelect}
                  format={values =>
                    values
                      ? values.map(value => ({
                          value: value.objectId,
                          label: value.regionName,
                        }))
                      : []
                  }
                  normalize={values => {
                    return (
                      regions &&
                      regions.filter(
                        region =>
                          values &&
                          values.findIndex(
                            val => val.value === region.objectId
                          ) > -1
                      )
                    )
                  }}
                  selectInput={<Input id="select-multiple-chip" />}
                  multiple
                />
              </div>
              <div>
                <Field name="job" component={CustomTextField} label="Job" />
              </div>
              <div>
                <Field
                  name="phoneNumber"
                  component={CustomTextField}
                  label="Phone Number"
                />
              </div>

              <Typography
                variant="h5"
                style={{ textAlign: 'center', marginTop: 10 }}
                gutterBottom
              >
                Account Details
              </Typography>
              <Divider style={{ marginBottom: '20px' }} />
              <div>
                <Field
                  name="accountName"
                  component={CustomTextField}
                  label="Account Name"
                />
              </div>
              <div>
                <Field
                  name="accountNumber"
                  component={CustomTextField}
                  label="Account Number"
                />
              </div>
              <div>
                <Field
                  name="paypalAccount"
                  component={CustomTextField}
                  label="Paypal Account"
                />
              </div>

              <CardActions>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={this.props.fetching}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => this.props.history.push('/expert')}
                >
                  Back to list
                </Button>
              </CardActions>
            </form>
          }
          footer={''}
        />
        <SweetAlert
          type={errorMessage ? 'error' : 'success'}
          show={saved || (errorMessage ? true : false)}
          title={errorMessage ? 'Error' : 'Notice'}
          text={errorMessage ? errorMessage : 'Saved'}
          onConfirm={this.hideAlert.bind(this)}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  record: state.expert.record,
  firstNameValue: selector('user.firstName', state),
  lastNameValue: selector('user.lastName', state),
  regions: state.expert.regions,
  fetching: state.expert.fetching,
  fetched: state.expert.fetched,
  saving: state.expert.saving,
  saved: state.expert.saved,
  errorMessage: state.expert.errorMessage,
  initialValues: state.expert.record,
})

const mapDispatchToProps = { ...expertActions }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    // a unique name for the form
    form,
    onSubmit,
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ExpertsForm)
)
